<script>
  import Datepicker from "vuejs-datepicker"
  import { dateFormat } from "@/core/services/helpers"
  import { ptBR } from "vuejs-datepicker/dist/locale"
  import moment from "moment"

  export default {
    components: {
      Datepicker,
    },
    props: {
      seasonality: {
        type: Object,
        required: true,
      },
    },
    data: () => {
      return {
        locale: ptBR,
        dateFormat,
        disabledDatesBegin: {
          to: null,
          from: null,
        },
        disabledDatesEnd: {
          to: null,
          from: null,
        },
        errors: {
          desazonalidade: false,
          dtinicio: false,
          dtfim: false,
        },
      }
    },
    beforeMount() {
      this.disabledDatesBegin.to = moment().toDate()
      this.disabledDatesEnd.to = moment().toDate()
    },
    methods: {
      validateForm() {
        if (!this.seasonality.desazonalidade) {
          this.errors.desazonalidade = true
          this.$toast.error({
            title: "Erro",
            message: "Nome do Período é obrigatório.",
          })
        } else {
          this.errors.desazonalidade = false
        }
        if (!this.seasonality.dtinicio) {
          this.errors.dtinicio = true
          this.$toast.error({
            title: "Erro",
            message: "Data de Início é obrigatória.",
          })
        } else {
          this.errors.dtinicio = true
        }
        if (!this.seasonality.dtfim) {
          this.errors.dtfim = true
          this.$toast.error({
            title: "Erro",
            message: "Data de Fim é obrigatória.",
          })
        } else {
          this.errors.dtfim = false
        }
        if (this.seasonality.dtinicio && this.seasonality.dtfim) {
          if (
            moment(this.seasonality.dtinicio).isAfter(this.seasonality.dtfim)
          ) {
            this.$toast.error({
              title: "Erro",
              message: "Data de Início não pode ser maior que a Data de Fim.\n",
            })
            return
          }
          if (
            moment(this.seasonality.dtinicio).isBefore(
              moment().subtract(1, "days")
            )
          ) {
            this.$toast.error({
              title: "Erro",
              message: "Data de Início não pode ser menor que a data atual.\n",
            })
            return
          }
        }
        if (
          this.seasonality.dtinicio &&
          this.seasonality.dtfim &&
          this.seasonality.desazonalidade
        ) {
          this.submit()
        }
      },
      submit() {
        this.$emit("submit")
      },
      goBack() {
        this.$router.go(-1)
      },
    },
  }
</script>
<style>
  .date-picker-seasonality {
    height: 93% !important;
  }
  .date-picker-seasonality > .vdp-datepicker__calendar {
    height: 100% !important;
  }
</style>
<template>
  <div class="grid grid-flow-row">
    <form class="p-10 grid grid-cols-9 gap-6" @submit.prevent="validateForm">
      <div class="text-sm col-span-3 grid grid-flow-row">
        <div>
          <label
            class="form-label"
            :class="{ 'text-red-500': errors.desazonalidade && !seasonality.desazonalidade }"
          >
            Nome do Período
          </label>
          <input
            id="periodo-nome"
            v-model="seasonality.desazonalidade"
            type="text"
            class="form-input"
            :class="{ 'bg-red-100 border-red-400': errors.desazonalidade && !seasonality.desazonalidade }"
          >
        </div>
        <div class="">
          <label class="form-label">Informações da Sazonalidade</label>
          <textarea
            id="periodo-informacoes"
            v-model="seasonality.deinfosazonalidade"
            class="form-input"
            rows="10"
          />
        </div>
      </div>
      <div class="text-sm col-span-3">
        <label
          class="form-label"
          :class="{ 'text-red-500': errors.dtinicio && !seasonality.dtinicio }"
        >
          Início
        </label>
        <Datepicker
          v-model="seasonality.dtinicio"
          :disabled-dates="disabledDatesBegin"
          :format="dateFormat"
          :language="locale"
          :full-month-name="true"
          input-class="form-input mb-0"
          :inline="true"
          class="date-picker-seasonality"
        />
      </div>
      <div class="text-sm col-span-3">
        <label
          class="form-label"
          :class="{ 'text-red-500': errors.dtfim && !seasonality.dtfim }"
        >
          Fim
        </label>
        <Datepicker
          v-model="seasonality.dtfim"
          :disabled-dates="disabledDatesEnd"
          :format="dateFormat"
          :language="locale"
          :full-month-name="true"
          input-class="form-input mb-0"
          :inline="true"
          class="date-picker-seasonality"
        />
      </div>
      <div class="col-span-3 col-start-7 grid grid-cols-2 gap-15">
        <button type="button" class="btn-secondary uppercase" @click="goBack">
          Voltar
        </button>
        <button class="form-submit">Salvar</button>
      </div>
    </form>
  </div>
</template>
